import { CancelToken } from 'axios';

import { CPCU_PROGRAM_ID } from '@app/constants/program-steps';

export async function initializePurchaseForm(
	actions: any,
	courseCodes: string[],
	topicCourseIds: string[],
	programId?: string,
	programIds?: string[],
	cancelToken?: CancelToken,
) {
	return Promise.all([
		actions.getMarketingCourses(courseCodes, cancelToken && cancelToken),
		actions.getMarketingTopicCourses(topicCourseIds, cancelToken),
		actions.getMarketingExamWindows(cancelToken),
		...(programIds && programIds.length > 0
			? [actions.getMarketingPrograms(programIds, cancelToken)]
			: []),
		...(String(programId) === CPCU_PROGRAM_ID
			? [actions.getMatriculation()]
			: []),
	]);
}
